export default __webpack_public_path__ + "static/media/BeltTorqueImg.26f21336.png";